import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import 'draft-js/dist/Draft.css';

import { Box, Typography, ListItem, ListItemText, InputAdornment } from '@mui/material';

import { languageFieldMap, nameFields } from '../../i18n';

import useGlobalStatus from '../../hook/useGlobalStatus';

import { SearchInput } from '../customComponent/form';
import { handleColorSystem } from '../customComponent/colorSystem';

import { AddOutlinedIcon, SearchIcon } from '../../constants/images';

import theme from '../../theme';


const CreateFieldsOptional = (props) => {
  const {
    media,
    optionalFields,
    reportLanguage,
    handleExpressionInput,
  } = props;

  const { locale, setLocale } = useGlobalStatus();
  const intl = useIntl();
  const [filterOptionFields, setFilterOptionFields] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem(media);
  const formatMedia = media.toLowerCase();

  useEffect(() => {
    const filterFields = () => {
      return optionalFields
        .filter(el => el.category !== 'custom' && el.category !== '固定欄位_0')
        .map(el => {
          const filterChild = el.child.filter(elem => {
            const lowerKeyword = searchKeyword.toLowerCase();
            return nameFields.some(
              key => elem[key] && elem[key].toLowerCase().includes(lowerKeyword)
            );
          })
          return { ...el, child: filterChild };
        });
    };

    if (searchKeyword) {
      setFilterOptionFields(filterFields());
    } else {
      setFilterOptionFields(filterFields);
    }
  }, [searchKeyword])

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
  };

  return (
    <>
      <SearchInput
        id="search"
        placeholder={intl.formatMessage({ id: "createFields.placeholder.searchFields" })}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        media={media}
        sx={{
          width: "100%",
          marginBottom: "10px",
          '& .MuiInputBase-input': {
            paddingLeft: 0,
          }
        }}
        value={searchKeyword}
        onChange={handleSearchInput}
      />

      <Box
        sx={{
          overflow: 'auto',
          height: '342px',
          padding: '8px 16px',
          border: `1px solid ${theme.palette.grey.w300}`,
          borderRadius: '4px',
        }}
      >
        {
          filterOptionFields.map((el, index) => {
            const formatCategory = (el.category)
              .replace(/_\d+$/, "")      // 移除尾端的 "_數字"
              .replace(/\s+/g, "")       // 移除所有空白
              .toLowerCase();           

            return (
              <>
                {
                  !searchKeyword &&
                  <Typography
                    key={`${el.category}_${index}`}
                    sx={{
                      margin: '8px 0',
                      padding: '4px 0 4px 8px',
                      backgroundColor: theme.palette.grey.w100,
                      borderRadius: '2px'
                    }}
                  >
                    {el.name === "自訂轉換欄" ? (
                      <FormattedMessage id={`${formatMedia}.field.category.conversionActionColumn`} />
                    ) : (
                      <FormattedMessage id={`${formatMedia}.field.category.${formatCategory}`} />
                    )}
                  </Typography>
                }
                {
                  el.child.map((item, index) => {
                    const nameKey = languageFieldMap[reportLanguage];
                    const display = item[nameKey] || item.name;
                    return (
                      <ListItem
                        key={`${item.expression}_${index}`}
                        onClick={() => {
                          handleExpressionInput({ inputType: 'field', operator: item.expression, display });
                        }}
                        sx={{
                          padding: '2px 0',
                          cursor: 'pointer',
                          '&:hover': { color: mainColor }
                        }}
                      >
                        <AddOutlinedIcon />
                        <ListItemText
                          primary={
                            item.type === 'CUSTOM' ? item.name :
                              <FormattedMessage id={`${formatMedia}.field.${item.expression}`} />
                          }
                          sx={{ paddingLeft: '4px' }}
                        />
                      </ListItem>
                    )
                  })
                }
              </>
            )
          })
        }
      </Box>
    </>
  )
}

export default CreateFieldsOptional;